import ExcelJS from "exceljs";
/**
 * Convert table and data into csv string
 * @param {*} headers
 * @param {*} tabledata
 * @returns Blob.
 * @see https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
 */

// Helper function to check if a value is numeric
function isNumeric(value) {
  if (value === null || value === undefined || value === '') return false;
  // Check if it's a number
  if (typeof value === 'number') return true;
  // Check if it's a string that can be converted to a number
  if (typeof value === 'string') {
    // Remove commas and spaces, then check if it's a valid number
    const cleanValue = value.replace(/[, ]/g, '');
    return !isNaN(cleanValue) && !isNaN(parseFloat(cleanValue));
  }
  return false;
}

// Helper function to detect if a column contains mostly numeric data
function isColumnNumeric(tabledata, columnKey) {
  if (!tabledata || tabledata.length === 0) return false;
  
  let numericCount = 0;
  const totalRows = Math.min(tabledata.length, 10); // Check first 10 rows for efficiency
  
  for (let i = 0; i < totalRows; i++) {
    const value = tabledata[i][columnKey];
    if (isNumeric(value)) {
      numericCount++;
    }
  }
  
  // Consider column numeric if at least 70% of checked values are numeric
  return (numericCount / totalRows) >= 0.7;
}

export default async function TableToExcel(displaylocation, displaysector, location, sector, gas, fuel, emissiontype, year, headers, tabledata) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "ANGA";
  workbook.created = new Date();
  const sheet = workbook.addWorksheet("Data");

  const cols = [];
  for (let i = 0; i < headers.length; i++) {
    const h = headers[i];
    // the Financial Year column is not numeric
    const isNumericColumn = h.label !== 'Financial Year' && isColumnNumeric(tabledata, h.key); 
    cols.push({ 
      header: h.label, 
      key: h.key, 
      width: 32,
      style: isNumericColumn ? { numFmt: '#,##0.00' } : undefined
    });
  }
  sheet.columns = cols;

  for (let r = 0; r < tabledata.length; r++) {
    const row = tabledata[r];
    const data = [];
    for (let i = 0; i < headers.length; i++) {
      const h = headers[i];
      const value = row[h.key];
      
      // Convert numeric strings to numbers for proper Excel formatting
      if (isNumeric(value) && typeof value === 'string') {
        const cleanValue = value.replace(/[, ]/g, '');
        data.push(parseFloat(cleanValue));
      } else {
        data.push(value);
      }
    }    
    sheet.addRow(data);
  }

  if(location && displaylocation) {
    const t = [];
    t.push("Location: "+location);
    sheet.addRow(t);
  }
  if(sector && displaysector) {
    const t = [];
    t.push("Sector: "+sector);
    sheet.addRow(t);
  }
  if(gas) {
    const t = [];
    t.push("Gas: "+gas);
    sheet.addRow(t);
  }
  if(fuel) {
    const t = [];
    t.push("Fuel: "+fuel);
    sheet.addRow(t);
  }
  if(emissiontype) {
    const t = [];
    t.push("Emission: "+emissiontype);
    sheet.addRow(t);
  }
  if(year) {
    const t = [];
    t.push("Year: "+year);
    sheet.addRow(t);
  }

  const sourcerow = [];
  sourcerow.push("Source : https://greenhouseaccounts.climatechange.gov.au");
  sheet.addRow(sourcerow);

  const t = await workbook.xlsx.writeBuffer();
  return new Blob([new Uint8Array(t, 0, t.byteLength)], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
}
